import { CartTargetingDto } from "@intelligems/ig-types/dtos/cart-targeting";
import { CartTargetingFe } from "@intelligems/ig-types/fe-only/cart-targeting";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { replaceCartTargeting } from "@src/store/slices/cartTargeting";
import { setCheckoutBlockDisplayConditions } from "@src/store/slices/checkoutBlocks";
import { getCheckoutBlock } from "@src/store/slices/checkoutBlocks/selectors";

/**
 * Sets a block's `displayConditions`, keeping the `cartTargeting` slice in
 * sync the way Save reads it — `BlockDisplayConditionsSection`'s lazy-create
 * step and Ellie's `setCheckoutBlockDisplayConditions` tool both go through
 * this, so the two can't drift from each other.
 */
export const replaceCheckoutBlockDisplayConditions = createAsyncThunk<
  void,
  {
    checkoutBlockId: string;
    displayConditions: CartTargetingDto | undefined;
  }
>(
  "checkoutBlocks/replaceDisplayConditions",
  ({ checkoutBlockId, displayConditions }, { dispatch, getState }) => {
    const previousConditionId =
      getCheckoutBlock(checkoutBlockId)(getState())?.displayConditions?.id;

    dispatch(
      setCheckoutBlockDisplayConditions({ checkoutBlockId, displayConditions })
    );
    dispatch(
      replaceCartTargeting({
        cartTargetingIdsToRemove: previousConditionId
          ? [previousConditionId]
          : [],
        // Same cast `updateCartTargeting` applies to a compiled expression:
        // the Fe type requires `query` on every node.
        cartTargeting: displayConditions
          ? [displayConditions as CartTargetingFe]
          : [],
      })
    );
  }
);
